<template lang="html">
    <div class="doubleImage">
        <div class="half" v-if="!images[0]">
            <android-file-picker
                v-if="androidOpen1"
                :id="'content-double-image-1-' + record.ref"
                mode="single"
                type="Image"
            ></android-file-picker>
            <label class="plusIcon" @click="openFileAndroid(0)">
                <plus-icon class="icon" />
                <input
                    @change="selectFile(1)"
                    type="file"
                    accept="image/x-png,image/gif,image/jpeg,image/jpg"
                />
            </label>
        </div>

        <div
            v-else
            @click.prevent="imageIndex = 0"
            class="halfImage"
            :style="{ 'background-image': 'url(' + images[0] + ')' }"
        ></div>

        <div class="half" v-if="!images[1]">
            <android-file-picker
                v-if="androidOpen2"
                :id="'content-double-image-2-' + record.ref"
                mode="single"
                type="Image"
            ></android-file-picker>
            <label class="plusIcon" @click="openFileAndroid(1)">
                <plus-icon class="icon" />
                <input
                    @change="selectFile(2)"
                    type="file"
                    accept="image/x-png,image/gif,image/jpeg,image/jpg"
                />
            </label>
        </div>

        <div
            v-else
            @click.prevent="imageIndex = 1"
            class="halfImage"
            :style="{ 'background-image': 'url(' + images[1] + ')' }"
        ></div>

        <button v-if="editMode" class="button red" @click.prevent="deleteSection" type="button">
            <img src="@/assets/minus.svg" class="icon" />
        </button>

        <CoolLightBox :items="galleryImages" :index="imageIndex" @close="imageIndex = null">
        </CoolLightBox>
    </div>
</template>

<script>
import AndroidFilePicker from "@/components/Shared/Android-file-picker";
import { PlusIcon } from "vue-feather-icons";
import { imageURL } from "@/mixins/imageURL.js";
import { isAndroid } from "mobile-device-detect";
export default {
    name: "content-double-image",
    props: ["record", "value", "index", "editMode"],
    mixins: [imageURL],
    components: { PlusIcon, AndroidFilePicker },
    data() {
        return {
            image1: false,
            image2: false,
            images: [],
            galleryImages: [],
            imageIndex: null,
            imagesBackup: false,
            androidOpen1: false,
            androidOpen2: false,
            oWebViewInterface: window.nsWebViewInterface,
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set($val) {
                this.$emit("input", $val);
            },
        },
    },
    created() {
        if (this.record.image_urls) {
            this.imagesBackup = this.record.image_urls;

            this.record.image_urls.forEach((item, index) => {
                this.images[index] = this.imageURL(item);
            });

            this.galleryImages[0] = this.images[0];
            this.galleryImages[1] = this.images[1];
        } else if (this.record.images) {
            this.images = this.record.images;
            this.galleryImages = this.images;
        }

        this.oWebViewInterface.on(
            "fileRecieved-content-double-image-1-" + this.record.ref,
            (imageData) => {
                this.androidCreateFile1(imageData);
                this.androidOpen1 = false;
            },
        );

        this.oWebViewInterface.on(
            "fileRecieved-content-double-image-2-" + this.record.ref,
            (imageData) => {
                this.androidCreateFile2(imageData);
                this.androidOpen2 = false;
            },
        );
    },
    methods: {
        openFileAndroid(id) {
            if (isAndroid) {
                if (id == 0) {
                    this.androidOpen1 = true;
                } else {
                    this.androidOpen2 = true;
                }
            }
        },
        deleteSection() {
            this.$emit("sectionDeleted", this.index, this.record);
        },
        selectFile($image) {
            if ($image == 1) {
                this.createFile1(event.target.files[0]);
            } else {
                this.createFile2(event.target.files[0]);
            }
        },
        androidCreateFile1(string) {
            this.image1 = "data:image/png;base64," + String(string);
            this.images.splice(0, 1, "data:image/png;base64," + String(string));
            this.galleryImages[0] = "data:image/png;base64," + String(string);

            var images = [this.image1, this.image2];
            this.inputVal = images;

            if (this.image1 && this.image2) {
                this.$emit("saveData");
            }
        },
        androidCreateFile2(string) {
            this.image2 = "data:image/png;base64," + String(string);
            this.images.splice(1, 1, "data:image/png;base64," + String(string));
            this.galleryImages[1] = "data:image/png;base64," + String(string);

            var images = [this.image1, this.image2];
            this.inputVal = images;

            if (this.image1 && this.image2) {
                this.$emit("saveData");
            }
        },
        createFile1(file) {
            var reader = new FileReader();

            reader.onload = (readerEvt) => {
                var binaryString = readerEvt.target.result;
                var string = btoa(binaryString);
                this.image1 = "data:image/png;base64," + String(string);

                this.images.splice(0, 1, "data:image/png;base64," + String(string));
                this.galleryImages[0] = "data:image/png;base64," + String(string);

                var images = [this.image1, this.image2];
                this.inputVal = images;

                if (this.image1 && this.image2) {
                    this.$emit("saveData");
                }
            };

            reader.readAsBinaryString(file);
        },
        createFile2(file) {
            var reader2 = new FileReader();

            reader2.onload = (readerEvt) => {
                var binaryString = readerEvt.target.result;
                var string = btoa(binaryString);
                this.image2 = "data:image/png;base64," + String(string);

                this.images.splice(1, 1, "data:image/png;base64," + String(string));
                this.galleryImages[1] = "data:image/png;base64," + String(string);

                var images = [this.image1, this.image2];
                this.inputVal = images;

                if (this.image1 && this.image2) {
                    this.$emit("saveData");
                }
            };

            reader2.readAsBinaryString(file);
        },
    },
};
</script>

<style lang="scss" scoped>
.doubleImage {
    position: relative;
}

.halfImage {
    width: calc(50% - 10px);
    margin-bottom: 20px;
    height: 200px;
    background-size: cover;
    border-radius: $radius;
    &:first-of-type {
        margin-right: 20px;
    }
}
.button {
    position: absolute;
    right: 10px;
    width: 40px !important;
    height: 40px !important;
    border-radius: 8px !important;
    top: -10px;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
    .icon {
        width: 9px;
    }
}
</style>
